/*
 *
 * ExportPopUp
 *
 * @version 1.0.0
 * @author Magarelli-Fabrizio
 * @since 07-Nov-2024
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  cancel: <PortalMessage id='t.app.project.btn.cancel' defaultMessage='Cancel' />,
  dateSection: <PortalMessage id='t.app.orders.export.popup.dateSection' defaultMessage='Date range' />,
  from: <PortalMessage id='t.app.orders.export.popup.from' defaultMessage='From' />,
  to: <PortalMessage id='t.app.orders.export.popup.to' defaultMessage='To' />,
  exportDescription: (
    <PortalMessage id='t.app.orders.export.popup.alert' defaultMessage='This export has filters applied' />
  ),
  exportAriaTitle: (
    <PortalMessage id='t.app.orders.export.popup.ariaTitle' defaultMessage='Export pupup title: Export data' />
  ),
  exportAriaDescription: (
    <PortalMessage
      id='t.app.orders.export.popup.ariaDescription'
      defaultMessage='Export pupup description: This export has filters applied'
    />
  ),
  exportTitle: <PortalMessage id='t.app.orders.export.popup.title' defaultMessage='Export data' />,
  format: <PortalMessage id='t.app.orders.export.popup.format' defaultMessage='Format' />,
  save: <PortalMessage id='t.app.project.btn.save' defaultMessage='Save' />,
  dateRange: <PortalMessage id='t.app.orders.export.popup.dateRange' defaultMessage='Date Range' />,
  timeRange: <PortalMessage id='t.app.orders.export.popup.timeRange' defaultMessage='Time Range' />,
  timeError: <PortalMessage id='t.app.orders.export.popup.timeError' defaultMessage='The time range is not valid' />
}

export const captions = defineMessages({
  exportAriaDescription: {
    id: 't.app.orders.export.popup.ariaDescription',
    defaultMessage: 'Export pupup description: This export has filters applied'
  },
  exportAriaTitle: {
    id: 't.app.orders.export.popup.ariaTitle',
    defaultMessage: 'Export pupup title: Export data'
  },
  csv: {
    id: 't.app.orders.export.format.csv',
    defaultMessage: 'Csv'
  },
  calendar: {
    id: 't.app.accessibility.icons.input.calendar.ariaLabel',
    defaultMessage: 'Calendar icon'
  },
  xlsx: {
    id: 't.app.orders.export.format.excel',
    defaultMessage: 'Xlsx'
  },

  TODAY: {
    id: 't.app.orders.export.dates.today',
    defaultMessage: 'Today'
  },

  CURRENT_MONTH: {
    id: 't.app.orders.export.dates.currentMonth',
    defaultMessage: 'Current Month'
  },

  LAST_SEVEN_DAYS: {
    id: 't.app.orders.export.dates.lastSevenDays',
    defaultMessage: 'Last 7 Days'
  },

  LAST_MONTH: {
    id: 't.app.orders.export.dates.lastMonth',
    defaultMessage: 'Last Month'
  },

  CUSTOM: {
    id: 't.app.orders.export.dates.custom',
    defaultMessage: 'Personalized'
  },

  close: {
    id: 't.app.accessibility.project.btn.close.ariaLabel',
    defaultMessage: 'Close'
  },
  from: {
    id: 't.app.orders.research.from',
    defaultMessage: 'From'
  },
  to: {
    id: 't.app.orders.research.to',
    defaultMessage: 'To'
  }
})

export default formattedMessage
